import { Outlet } from 'react-router-dom'
import { PostsProvider } from '@/components/common/posts/posts.provider'
import { posts } from '@/app/(site-officiel)/actualites/flash-infos/post-data'

export default function FlashInfosLayout() {
  return (
    <PostsProvider storageKey="flash_infos_current_article" postsBasePath="/actualites/flash-infos" posts={posts}>
      <Outlet />
    </PostsProvider>
  )
}
